import { applySnapshot, flow, getRoot, types } from 'mobx-state-tree';

import spotifyService from '../services/spotifyService';
import PlaylistModel from './models/PlaylistModel';
import UserModel, { IUserModel } from './models/UserModel';
import { IRootStore } from './RootStore';

const MeStore = types
    .model('MeStore', {
        profile: types.maybe(types.safeReference(UserModel, { acceptsUndefined: false })),
        playlists: types.optional(types.map(PlaylistModel), {}),
    })
    .volatile(() => ({
        selectedPlaylist: '',
    }))
    .views(self => ({
        get selectedPlaylistTracks() {
            const selectedPlaylist = self.playlists.get(self.selectedPlaylist);
            if (!selectedPlaylist || !selectedPlaylist.tracks.size) {
                return [];
            }
            return Array.from(selectedPlaylist.tracks.values());
        },
    }))
    .actions(self => {
        const rootStore: IRootStore = getRoot(self);

        const setUser = (userProfile: IUserModel) => {
            try {
                const user: IUserModel = {
                    id: userProfile.id,
                    displayName: userProfile.displayName,
                    photoURL: userProfile.photoURL,
                    email: userProfile.email,
                };
                self.profile = rootStore.users.addUser(user);
            } catch (error) {
                console.log(error);
            }
        };

        const removeUser = () => {
            applySnapshot(self, {});
        };

        const getPlaylists = flow(function*() {
            try {
                const response: SpotifyApi.ListOfUsersPlaylistsResponse = yield spotifyService.getUserPlaylists();
                response.items.forEach(playlist => {
                    self.playlists.set(playlist.id, {
                        id: playlist.id,
                        name: playlist.name,
                        uri: playlist.uri,
                        imageUrl: playlist.images.length ? playlist.images[0].url : '',
                    });
                });
            } catch (error) {
                if (error.status === 401) {
                    const rootStore: IRootStore = getRoot(self);
                    rootStore.auth.signOut();
                }
            }
        });

        const selectPlaylist = (playlistId: string) => {
            self.selectedPlaylist = playlistId;
            self.playlists.get(playlistId)?.getTracks();
        };

        const deselectPlaylist = () => {
            self.selectedPlaylist = '';
        };

        return {
            removeUser,
            setUser,
            getPlaylists,
            selectPlaylist,
            deselectPlaylist,
        };
    });

export default MeStore;
